<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_8"><em class="italic">“The most beautiful rocks are those that have weathered the storm.”</em></a></p><a id="page_8">
<p class="center1">—Unknown</p>
<div class="img_container">
<img alt="images" src="images/fig2.jpg" style="width:30%;"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm01.vue?27e1ac60